var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRakez(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1186.9px",
    height: "1200.8px",
    viewBox: "0 0 1186.9 1200.8",
    style: {
      enableBackground: "new 0 0 1186.9 1200.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:url(#SVGID_6_);}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#073E61;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "RAK Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 688.267,
    y1: 1519.0776,
    x2: 1118.1239,
    y2: 774.5438,
    gradientTransform: "matrix(1 0 0 -1 0 1528)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8DD3D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B3AE"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M720.7,0c-37,0.5-66.5,31-66,68c0.2,11.4,3.3,22.7,9,32.6l58.1,100.6v-0.1l281.9,488.2h116.2 c22.8,0,44,11.5,56.3,30.6L780,33.8c0.2,0.3,0.3,0.7,0.5,1c-0.2-0.4-0.4-0.8-0.7-1.3C768,13.1,746.4,0.3,722.8,0H720.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 375.9301,
    y1: 1306.5204,
    x2: 68.7965,
    y2: 774.555,
    gradientTransform: "matrix(1 0 0 -1 0 1528)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#86D3E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00ADE5"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.2,212.6c-25.6,0.1-48.9,14.6-60.1,37.6L10.7,719.9c12.3-19.1,33.5-30.6,56.3-30.6h116.1l159.3-275.6 v-0.1l57.2-99.1c19.3-31.6,9.4-72.8-22.1-92.1C366.9,215.9,354.7,212.5,342.2,212.6L342.2,212.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1186.9149,
    y1: 771.6949,
    x2: 617.89,
    y2: 771.6949,
    gradientTransform: "matrix(1 0 0 -1 0 1528)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8DD3D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B3AE"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1003.8,689.3H656.5l-0.1,0l17.7,30.5c20.2,31,11.4,72.5-19.6,92.7c-10.9,7.1-23.6,10.9-36.6,10.8h502 c37,0,67-30,67-67c0-37-30-67-67-67H1003.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.1602,
    y1: 771.745,
    x2: 323.68,
    y2: 771.745,
    gradientTransform: "matrix(1 0 0 -1 0 1528)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#86D3E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00ADE5"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M183.1,689.3H67c-37-0.1-67.1,29.8-67.2,66.8c-0.1,37,29.8,67.1,66.8,67.2l0,0h257c-37,0-67-29.9-67.1-66.9 c0-12.9,3.7-25.6,10.8-36.5l17.5-30.6L183.1,689.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.1913,
    y1: 713.6435,
    x2: 721.5613,
    y2: 1460.7935,
    gradientTransform: "matrix(1 0 0 -1 0 1528)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8DD3D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B3AE"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M470.7,367.9l-77.4,134L285.1,689.3h-0.2l-17.5,30.7c-19.3,31.6-9.4,72.8,22.1,92.1 c31.6,19.3,72.8,9.4,92.1-22.1c0.3-0.6,0.7-1.1,1-1.7l0.1-0.3l87.9-152.1l77.4-134.1L721.8,201l-56.4-97.8 c-13.5-21-14.1-47.8-1.8-69.4L470.7,367.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 651.2246,
    y1: 713.5766,
    x2: 342.6577,
    y2: 1248.0206,
    gradientTransform: "matrix(1 0 0 -1 0 1528)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#86D3E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00ADE5"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M409.4,279.8c0,12.8-3.7,25.4-10.7,36.2l-56.4,97.7l51,88.2l77.4,134l88,152.4c11.7,21.6,34.3,35.1,58.9,35.1 c37,0,67.3-30,67.3-67c0-12.9-3.8-25.6-10.8-36.4l-17.7-30.7l0,0L548.1,501.8l-77.4-134l-70.1-121.3 C406.4,256.6,409.4,268.1,409.4,279.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M317.9,907.5h-89.4v52.7h88.8l0,0c19,0,34.4,15.4,34.4,34.4v34H244.2c-47.5,0.5-85.7,39.5-85.2,87 c0.5,46.8,38.3,84.7,85.2,85.2h153.4c3.5,0,6.3-2.8,6.3-6.3V993.6C404,946.1,365.4,907.5,317.9,907.5z M351.7,1142.5 c0,3.5-2.8,6.3-6.3,6.3c0,0,0,0,0,0H245.3c-19,0-34.4-15.4-34.4-34.4s15.4-34.4,34.4-34.4h106.4V1142.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M197.6,960.2v-52.7H86.1C38.5,907.5,0,946.1,0,993.6v200.8c0,3.5,2.8,6.3,6.3,6.3c0,0,0,0,0,0h46V994.5 c0-19,15.4-34.4,34.4-34.4l0,0L197.6,960.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1186.9,907.6H940.8v46c0,3.5,2.8,6.3,6.3,6.3c0,0,0,0,0,0h168.3L941,1148.4l-0.1,52.3h239.8 c3.5,0,6.3-2.8,6.3-6.3c0,0,0,0,0,0v-46h-174.3l174.2-188.5V907.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M823.9,1079.7c47.5,0,86.1-38.5,86.1-86.1s-38.5-86.1-86.1-86.1h-73.6c-47.5,0-86.1,38.5-86.1,86.1 c0,0,0,0,0,0v121c0,47.5,38.5,86.1,86.1,86.1c0,0,0,0,0,0H910v-52.7H750.9l0,0c-19,0-34.4-15.4-34.4-34.4v-34L823.9,1079.7z  M716.5,1028.3v-34.4l0,0c0-19,15.4-34.4,34.4-34.4h72c19,0,34.4,15.4,34.4,34.4c0,19-15.4,34.3-34.4,34.4H716.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M584.4,907.5l-97.3,105.1v-98.8c0-3.5-2.8-6.3-6.3-6.3c0,0,0,0,0,0h-46.1v286.9c0,3.5,2.8,6.3,6.3,6.3h46 v-105l97,105h71.7l-135.6-146.5l135.7-146.7H584.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRakez);
export default __webpack_public_path__ + "static/media/RAKEZ.66e8a41578755b2cdea89c236234fc0f.svg";
export { ForwardRef as ReactComponent };